export const headingH1 = "lg:text-3xl md:text-xl text-lg font-extrabold";
export const headingH2 = "lg:text-2xl md:text-xl text-lg";
export const headingH3 = "lg:text-xl md:text-lg text-base";
export const paragraphe = "lg:text-lg md:text-base text-sm";
export const shadowTuile = "shadow-dropShadow stroke-2 stroke-[#B7B7B7] rounded-3xl";
export const paymentShadow = "30px -17px 15px -3px rgba(0,0,0,0.1)";

export const colors = {
  first: "#0054A3", //bleu
  second: "#3FD3E6", //bleu clair
  radio: "#219CFF",
  profile: "#92D3FF", //bleu clair
  button: "#0074E4", //bleu
  bgInputLight: "#F2F5FB", //bleu clair
  third: "#FF724F", //orange
  normal: "#4D4D4D", //gris
  star: "#FFCE31", //jaune
  transparent: "transparent", //transparent
  current: "currentColor", //current
  grey: "#808080", //gris
  light_gray: "#DEDEDE", //gris clair
  validation_green: "#8CC63F", //vert
  inputGray: "#D2D2D2", //gris
  bgcolorTuile: "#F2F9FF", //bleu clair
  bgColorRegisterClient: "#004066", //bleu
};
